import script from "./TmsShipping.vue?vue&type=script&setup=true&lang=js"
export * from "./TmsShipping.vue?vue&type=script&setup=true&lang=js"

import "./TmsShipping.vue?vue&type=style&index=0&id=84d55b96&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/idaas_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84d55b96"]])

export default __exports__